import { styled } from '@mui/material/styles';
import StyledAgentImage from '../../styles/StyledAgentImage';

const StyledWelcomeAgentImage3 = styled(StyledAgentImage)`
  ${({ theme }) => theme.breakpoints.up('sm')} {
    width: 48%;
  }

  ${({ theme }) => theme.breakpoints.up('md')} {
    width: 170px;
    position: absolute;
    bottom: 6%;
    left: 42%;
    top: auto;
    transform: translateX(-50%) rotate(-2deg);
  }

  ${({ theme }) => theme.breakpoints.up('lg')} {
    width: 185px;
  }
`;

export default StyledWelcomeAgentImage3;
